"use client";

import { createContext, useContext, useEffect, useState } from "react";

export interface AccountState {
	status: "idle" | "error" | "success" | "info";
	message?: string;
	isPermanentBanner?: boolean;
}

interface ContextProps {
	accountState: AccountState;
	setAccountState: (
		state: AccountState | ((prevState: AccountState) => AccountState),
	) => void;
}

interface Props {
	children: React.ReactNode;
}

const Context = createContext({} as ContextProps);

export const AccountStatusProvider = ({ children }: Props) => {
	const [accountState, setAccountState] = useState<AccountState>({
		status: "idle",
		message: "",
		isPermanentBanner: false,
	});

	useEffect(() => {
		if (accountState.status !== "idle" && !accountState.isPermanentBanner) {
			setTimeout(() => {
				setAccountState({ status: "idle", message: "" });
			}, 5000);
		}
	}, [accountState, setAccountState]);

	const value = {
		accountState,
		setAccountState,
	};

	return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useAccountStatusContext = () => {
	const context = useContext(Context);

	if (!context) {
		throw new Error(
			"useAccountStatusContext must be used within a AccountStatusProvider",
		);
	}

	return context;
};
